import React, { useState } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { getEmailApiUrl } from "../utils/getEmailApiUrl";

export default function BBFExitIntentModal({ show, setShow, markLeadCaptured }) {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value.trim();

    // A) validation (empty/invalid email)
    if (!email) {
      alert("Please enter a valid email address.");
      return;
    }

    const SUCCESS_ALERT =
  "✅ Thanks! Check your email for a confirmation link to finish signing up. If you don't see it in a minute, check your Spam/Promotions folder.";


    setLoading(true);

    try {
      // ✅ new endpoint + minimal payload
      const response = await fetch(`${getEmailApiUrl('/subscribe')}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          first_name: null,
          purpose: "subscribe"
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        console.error("❌ Subscribe failed:", data.error || data);
        alert(data?.error || "Something went wrong. Please try again.");
        return;
      }

      // ✅ Treat duplicate as success
      if (data?.success) {
        alert(SUCCESS_ALERT);
        markLeadCaptured(); // ✅ Prevent all future email popups
        setShow(false);
      } else {
        console.warn("⚠️ Unexpected response:", data);
        alert("Unexpected response. Please try again.");
      }
    } catch (err) {
      // console.error("❌ Error submitting lead:", err);
      alert("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleNoThanks = () => setShow(false);

  return (
    <Modal
      open={show}
      aria-labelledby="exit-intent-modal"
      disableEscapeKeyDown
      disableEnforceFocus
    >
      <Box
        sx={{
          maxWidth: 420,
          bgcolor: "#fff",
          borderRadius: "12px",
          boxShadow: 24,
          p: 4,
          textAlign: "center",
          mx: "auto",
          mt: "10vh",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", mb: 2, color: "#b71c1c", textTransform: "uppercase" }}
        >
          WAIT — BEFORE YOU LEAVE!
        </Typography>

        <Typography
          variant="h6"
          sx={{ mb: 2, fontWeight: "600", color: "#000", lineHeight: 1.4 }}
        >
          Our investigation exposes <strong>Biden’s Butler connection</strong> —
          and how 10/7 was connected.
        </Typography>

        <Box sx={{ textAlign: "left", mb: 3, fontSize: "16px", lineHeight: 1.6 }}>
          <p>✔ 125 named in a <strong>Pending RICO Complaint.</strong></p>
          <p>✔ Evidence that locks in our Criminal Referral</p>
          <p>✔ Tools to fight back before it’s too late</p>
        </Box>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email address"
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              marginBottom: "16px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
            required
          />
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
              width: "100%",
              bgcolor: "#d32f2f",
              fontSize: "16px",
              fontWeight: "bold",
              py: 1.2,
              "&:hover": { bgcolor: "#b71c1c" },
            }}
          >
            {loading ? "Submitting..." : "YES — SHOW ME THE TRUTH"}
          </Button>
        </form>
        <Typography
          variant="caption"
          sx={{ mt: 1.5, display: "block", color: "#777" }}
        >
          We’ll email you a confirmation. Unsubscribe anytime.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mt: 2,
            fontSize: "14px",
            color: "#555",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={handleNoThanks}
        >
          No thanks, I’ll let the Deep State keep winning.
        </Typography>
      </Box>
    </Modal>
  );
}
